import React, { useState } from "react"
import { Card } from "frontend/components/layout"
import { Heading } from "frontend/components/text"
import { Icon, SocialIcon } from "frontend/components/icons"
import { CopyableText } from "frontend/components/forms"
import t from "frontend/utils/translations"
import { isIncentivizedUpload } from "frontend/utils/upload"
import { openSharePopup } from "frontend/utils/share"

import styles from "./PublishedDisplay.module.css"
import EmbeddedSlideshow from "./EmbeddedSlideshow"
import { PRIVACY_MAP } from "./constants"
import MobileShare from "./MobileShare"
import IncentivizedUploadSuccess from "./IncentivizedUploadSuccess"

const PublishedDisplay = ({ slideshow, embedUrl }) => {
  const url = slideshow.slideshow_url
  const fullUrl = `${window.location.protocol + "//" + window.location.host}/${url}`

  const privacy = PRIVACY_MAP[slideshow.detailed_privacy_level]

  const handleSocialShare = (type) => {
    openSharePopup(type, slideshow)
  }

  if (isIncentivizedUpload()) {
    return <IncentivizedUploadSuccess />
  }

  return (
    <Card className={styles.container} testId="published-display">
      <div className={styles.slideshowContainer}>
        <EmbeddedSlideshow embedUrl={embedUrl} />
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.headingContainer}>
          <Heading size={4} className={styles.title}>
            {slideshow.slideshow_title}
          </Heading>
          <a href={url} target="_blank">
            <Icon name="external-link" isSelectable={false} />
          </a>
        </div>
        {privacy === "public" && (
          <div className={styles.socialContainer}>
            <SocialIcon className={styles.socialIcon} type="twitter" onClick={handleSocialShare} />
            <SocialIcon className={styles.socialIcon} type="facebook" onClick={handleSocialShare} />
            <SocialIcon className={styles.socialIcon} type="linkedin" onClick={handleSocialShare} />

            <MobileShare onShare={handleSocialShare} link={fullUrl} embedCode={slideshow.embed_code} />
          </div>
        )}

        {privacy !== "onlyme" && (
          <div className={styles.linkContainer}>
            <CopyableText id="url" label="URL" text={fullUrl} />
            {slideshow.show_embed_url && (
              <div>
                <CopyableText id="embed" label={t("upload.published.embed")} text={slideshow.embed_code} />
                <p className={styles.embedExplanation}>{t("upload.published.embed_prompt")}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </Card>
  )
}

export default PublishedDisplay
